import React from 'react'
import { Divider, Progress, Tooltip } from 'antd'
import styled from 'styled-components'
import { statusMap } from './constants'
import { t } from '@/i18n'

interface TaskContentProps {
  taskInfoModel: any[]
  convertTaskInfo: any
  taskInfo: any
}

const TaskContentComponent: React.FC<TaskContentProps> = ({
  taskInfoModel,
  convertTaskInfo,
  taskInfo,
}) => {
  const renderTaskItem = (item: any, index: number) => {
    const value =
      item.type && item.type !== 'array' && item.type !== 'object'
        ? convertTaskInfo[item.value as string]
        : item.value

    if (value && typeof value === 'object') {
      return renderProgressInfo(item, value, index)
    } else {
      return renderSimpleItem(item, value, index)
    }
  }

  const renderProgressInfo = (item: any, value: any, index: number) => (
    <div key={index} className="progress-info">
      <span className="label">{item.key}：</span>
      {value.map((v: any, i: number) => {
        if (v.value === 'progressRate') {
          return (
            <Progress
              key={i}
              strokeColor={{
                '0%': '#dfe7f9',
                '100%': '#0346F2',
              }}
              success={{ percent: -1 }}
              percent={convertTaskInfo[v.value as string]}
            />
          )
        } else {
          return renderStatusItem(v, i)
        }
      })}
    </div>
  )

  const renderStatusItem = (v: any, i: number) => (
    <div
      key={i}
      className={v.value}
      style={
        v.value === 'isFinished'
          ? {
              background: statusMap[taskInfo?.[v.value as number]]?.background,
              color: statusMap[taskInfo?.[v.value as number]]?.color,
            }
          : {}
      }
    >
      {v.value === 'executeSuccessCount' ? (
        <Tooltip title={t('执行成功用例数量')}>
          <span>{taskInfo?.[v.value as string]}</span>
        </Tooltip>
      ) : (
        <span>
          {v.value === 'isFinished'
            ? statusMap[taskInfo?.[v.value as number]]?.label
            : taskInfo?.[v.value as string]}
        </span>
      )}
      {v.value === 'executeSuccessCount' && (
        <span style={{ color: '#666', margin: '0 4px' }}>
          /
          <Tooltip title={t('执行失败用例数量')}>
            <span className="execute_fail_count">{taskInfo?.execFailItems?.length}</span>
          </Tooltip>
        </span>
      )}
    </div>
  )

  const renderSimpleItem = (item: any, value: any, index: number) => {
    if (item.value === 'bizAreaName') {
      return (
        <div key={index}>
          <span className="label">{item.key}：</span>
          <span>{taskInfo?.verificationInfo?.bizAreaName || '-'}</span>
          <Divider type="vertical" />
        </div>
      )
    } else if (item.value === 'agentName') {
      return (
        <div key={index}>
          <span className="label">{item.key}：</span>
          <span>{taskInfo?.verificationInfo?.agentName || '-'}</span>
          <Divider type="vertical" />
        </div>
      )
    }

    return (
      <div key={index}>
        <span className="label">{item.key}：</span>
        <span>{value || '-'}</span>
        <Divider type="vertical" />
      </div>
    )
  }

  return <TaskContent>{taskInfoModel.map(renderTaskItem)}</TaskContent>
}

export default TaskContentComponent

const TaskContent = styled.div`
  display: flex;
  align-items: center;

  .label {
    color: #86909c;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .ant-divider-vertical {
    margin: 0 19px;
  }

  .progress-info {
    flex: 1;
    display: flex;
    height: 100%;

    .isFinished {
      width: 50px;
      height: 18px;
      border-radius: 9px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .ant-progress-line {
      font-size: 12px;
      width: 90%;
      margin-right: 20px;
    }

    .executeSuccessCount {
      color: #3586ff;
      font-size: 12px;
      flex-shrink: 0;
    }

    .execute_fail_count {
      color: #f5222d;
      font-size: 12px;
      flex-shrink: 0;
    }
  }
`
